export const Disclaimer = () => (
  <div
    data-testid="page-disclaimer"
    className="mt-16 sm:mt-20 pt-8 border-t border-white/[0.06] text-slate-500 text-xs leading-relaxed max-w-3xl mx-auto"
  >
    <p className="uppercase tracking-[0.3em] text-[10px] text-stardust/60 mb-3">A note before you go</p>
    <p>
      Astrarium produces astrological readings written with the help of artificial
      intelligence, grounded in traditional Western and Vedic astrological frameworks.
      Readings are intended for personal reflection, entertainment and curiosity.
      They are not medical, financial, legal or psychological advice. For decisions in
      those areas, please consult a qualified professional you trust.
    </p>
  </div>
);
